<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/withdrawRecord')"
      >
        <van-icon
          name="bars"
          size="25"
        />
      </div>
    </div>
    <div class="balance">
      <p>
        {{ utils_moneyMark() }}  {{ data.money }}
      </p>
      <p>
        {{ $t('invest.availableBalance') }}   
      </p>
    </div>
    <div class="balance">
      <dl class="ratio-info">
        <dd><span class="text-gray">{{ $t('cash.abletimes') }}</span><em>{{ data.cash_maxnum }} {{ $t('cash.time') }}</em></dd>
        <dd><span class="text-gray">{{ $t('cash.usdtimes') }}</span><em>{{ data.cashnum }} {{ $t('cash.time') }}</em></dd>
        <dd><span class="text-gray">{{ $t('cash.isable') }}</span><em>{{ $t('cash.yes') }}</em></dd>
        <dd><span class="text-gray">{{ $t('cash.mincash') }}</span><em>{{ utils_moneyMark() }} {{ data.min_cash }} </em></dd>
      </dl>
    </div>
    <div class="wrap_box wrap1">
      <div class="withdraw_wrap">
        <p>{{ $t('cash.amount') }}</p>
        <div class="flex_center">
          <!-- <span>{{utils_moneyMark()}}</span> -->
          <span>{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money" 
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('cash.withdrawableAmount') + ' ' + data.money"
            @input="changeAmount"
          >
        </div>
        <p style="line-height: 30px;">
          {{ actualAmount }}
        </p>
        <p v-if="chargeTip">
          {{ chargeTip }}
        </p>
      </div>
      <div
        class="choose_bank"
        @click="doAddAddr"
      >
        <div>
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div>
          <span>
            <span
              v-if="accaddr"
              style="margin-right: 0;display: none;"
            >{{ maskAccount(accaddr) }}<br></span>
            {{ bank_name }}
          </span>
          <van-icon
            name="arrow"
            color="#999"
          />
        </div>
      </div>
      <!-- <div class="choose_bank">
                <div >
                    <span >Wallet</span>
                </div>
                <div>
                    <span >Please Select Wallet</span>
                    <i class="van-icon van-icon-arrow" style="color: rgb(153, 153, 153);">
                    </i>
                </div>
            </div> -->
      <!-- <van-action-sheet
              v-model="show"
              :actions="actions"
              :cancel-text="this.$t('shopd.cancelbtn')"
              :description="this.$t('cash.chooseWallet')"
              close-on-click-action
              @click="doAddAddr"
            /> -->
      <p class="canal_tips">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>
    <div
      class="basic_btn"
      @click="write_psd = true;submitType = 1;"
    >
      {{ $t('utils.submit') }}
    </div>
    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              :key="i"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
        Popup,
        PasswordInput,
        NumberKeyboard,
        Icon,
        ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "Cost",
        data() {
            return {
                data: {},
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
                chargeTip:'',
                charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
                eye:1,
                show: false,
                bank_name:this.$t('cash.chooseWallet'),
                actions: [],
                setPwd:false,
                submitType:1,
                type:1,
                accaddr:'',
                rate:1,
                mark:"$",
                actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            doAddAddr(){
                if(this.form.bank_id==0){
                    this.$router.push('/addcountUsdt')
                }
            },
            maskAccount(value) {
                var account = String(value || '').trim();
                if (account.length <= 6) {
                    return account ? '***' : '';
                }
                return account.slice(0, 3) + '***' + account.slice(-3);
            },
            onSelect(item){
                this.chargeTip = "";
                this.actualAmount = "";
                this.form.money = "";
                this.accaddr = item.acc;
                this.show = false;
                this.bank_name = item.name;
                this.form.bank_id = item.value;
                this.charge = item.charge;
                this.type = item.type;
                this.rate = item.rate;
                this.mark = item.mark;
                if(item.charge>0){
                    this.chargeTip = this.$t('cash.charge')+item.charge+"%";
                }else{
                    this.chargeTip = "";
                }
                if(item.value==0){
                    this.$router.push('/addcountUsdt')
                }
            },
            changeAmount(){
                this.chargeTip = "";
                var rateTip = "";
                var num = 2;
                    // if(this.type==1){
                    //     if(this.rate>10000){
                    //         num = 8;
                    //     }else if(this.rate>1000){
                    //         num = 6;
                    //     }else if(this.rate>10){
                    //         num = 4;
                    //     }
                    //     this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
                    //     rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
                    // }else{
                        this.actualAmount = "≈ "+(this.form.money/this.rate).toFixed(num)+" "+this.mark;
                        rateTip = "≈ "+(this.form.money/this.rate*this.charge/100).toFixed(num)+" "+this.mark+"";
                    // }
                if(this.charge>0){
                    this.chargeTip = this.$t('cash.charge')+""+rateTip;
                    // this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
                }
            },
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
                    this.write_psd = false;
                    this.form.password = this.psd_val;
                    if(this.submitType==1){
                        this.submit();
                    }else{
                        this.setIniPwdSubmit();
                    }
                    
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
                    this.data.money = this.data.money.toFixed(2);
                    this.setPwd = r.data.intPwd;
                    var bankvalue = [];
                    if(r.data.bank && r.data.bank.length>0){
                        r.data.bank.forEach(item => {
                            var account = item.account+"";
                            var itemAccount = account;
                            var tmpi = {
                                name: item.bank,
                                acc: itemAccount,
                                value: item.id,
                                charge:item.charge,
                                rate:item.rate,
                                type:item.type,
                                mark:item.mark
                            };
                            bankvalue.push(tmpi);
                            this.onSelect(tmpi);
                        })
                        
                        bankvalue.push()
                        this.actions = bankvalue;
                    }else{
                        bankvalue.push({
                            name: this.$t('cash.addWallet'),
                            value: 0,
                            color:"#FF0000",
                        })
                        this.actions = bankvalue;
                    }
                });
            },
            submit() {
                this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
                if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                    this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                    return false;
                }
                if (!this.form.password) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
            setIniPwdSubmit(){
                this.psd_val="";
                Fetch('/user/setIniPwd', {
                    password: this.form.password
                }).then(() => {
                    this.setPwd = false;
                });
            },
            setIniPwd(){
                this.submitType = 2;
                this.write_psd = true;
            }
        }
    };
</script>

<style lang="less" scoped>
    
    /deep/ .van-action-sheet__item {
        text-align: left;
    }
    /deep/ .van-popup--bottom{
        border-radius:0;
        padding-bottom: 15px;
    }
    .balance{
        background: #ffffff;
        border-radius: 6px;
        padding: 20px 0px;
        text-align: center;
        margin: 10px;
        p:nth-child(1){
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 15px;
        }
        p:nth-child(2){
            color: #999;
            font-weight: bold;
        }
    }

    .wrap1 {
        margin: 10px;
        box-shadow: none;
        background: none;
        .choose_bank{
            width: 100%;
            background: #FFFFFF;
            border-radius: 5px;
            padding:15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;
            div:nth-child(1){
                width: 20%;
                font-size: 14px;
                font-weight: bold;
                color: #999;
            }
            div:nth-child(2){
                width: 80%;
                text-align: right;
                font-size: 12px;
                font-weight: bold;
                color: #999;
            }
        }
        .withdraw_wrap{
            width: 100%;
            background: #ffffff;
            border-radius: 6px;
            padding: 16px 20px;
            margin-top: 10px;
            
            input{
                height: 18px;
                width: 85%;
                line-height: 18px;
                font-size: 14px;
            }
            div{
                span:nth-child(1){
                    font-size: 18px;
                    margin-right: 20px;
                    font-weight: bold;
                }
                span:nth-child(2){
                    font-size: 14px;
                    margin-left: 20px;
                    font-weight: bold;
                    width: 15%;
                    color: #999;
                    text-align: right;
                }
            }
            p:nth-child(1){
                font-size: 14px;
                font-weight: bold;
                color: #999;
                margin-bottom: 20px;
            }
            p:nth-child(3){
                color: #999;
                margin-top: 20px;
            }
        
        }
    }
    .canal_tips {
        border-top: 1px solid #ECECEC;
        display: block;
        padding: 16px;
        border-radius: 5px;
        background-color: #FFFFFF;
        line-height: 24px;
        color: #ee264d;;
        font-size: 12px;
        margin-top: 10px;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
        border-radius: 5px;
    }

    /deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }

    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
    
    .ratio-info{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        row-gap: 14px;
        padding: 0px 20px;
        line-height: 1;
        dd{
            margin: 0;
        }
        em {
            font-style: normal;
            font-size: 14px;
        }
    }
    .text-gray {
        color: #ababab;
    }
    .basic_wrap{
        position: relative;
        height: 100vh;
    }
    /deep/ .van-popup--bottom{
        position: absolute;
    }

    .basic_wrap {
        min-height: 100vh;
        height: auto;
        overflow-y: auto;
        padding-bottom: 88px;
        box-sizing: border-box;
        background: #f4f5fb;
        color: #061429;
    }

    .red_top_bg {
        position: sticky;
        top: 0;
        z-index: 10;
        height: 50px;
        background: #f7f8fd;
    }

    .big_tit {
        height: 50px;
        color: #202637;
        font-size: 14px;
        font-weight: 500;
        line-height: 50px;
		top: 0;
    }

    .back_left {
        position: absolute;
        left: 8px;
        top: 0px;
        width: 28px;
        height: 28px;
        background: transparent;
    }

    .back_left::before {
        content: '';
        position: absolute;
        left: 9px;
        top: 7px;
        width: 10px;
        height: 10px;
        border-left: 2px solid #071426;
        border-bottom: 2px solid #071426;
        transform: rotate(45deg);
    }

    .top_right {
        top: 10px;
        right: 14px;
        width: 28px;
        height: 28px;
        color: #3e4656;
        font-size: 20px;
        line-height: 28px;
    }

    .balance,
    .wrap1 .withdraw_wrap,
    .wrap1 .choose_bank,
    .canal_tips {
        overflow: hidden;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
    }

    .balance {
        margin: 16px 16px 0;
        padding: 18px 20px;
        text-align: left;
    }

    .balance p {
        margin: 0;
    }

    .balance > p:first-child {
        overflow: hidden;
        color: #050b18;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .balance > p:nth-child(2) {
        margin-top: 6px;
        color: #8b93a3;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }

    .ratio-info {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px 18px;
        padding: 0;
        line-height: 1.3;
    }

    .ratio-info dd {
        min-width: 0;
    }

    .text-gray,
    .ratio-info em {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .text-gray {
        color: #8b93a3;
        font-size: 12px;
        line-height: 18px;
    }

    .ratio-info em {
        margin-top: 5px;
        color: #050b18;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
    }

    .wrap1 {
        margin: 0 16px;
        background: transparent;
    }

    .wrap1 .withdraw_wrap,
    .wrap1 .choose_bank,
    .canal_tips {
        width: 100%;
        margin-top: 16px;
        padding: 16px 18px;
        box-sizing: border-box;
    }

    .wrap1 .withdraw_wrap > p:first-child,
    .wrap1 .choose_bank div:nth-child(1) span {
        color: #8b93a3;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }

    .wrap1 .withdraw_wrap .flex_center {
        min-height: 42px;
        justify-content: flex-start;
        margin-top: 8px;
        border-bottom: 1px solid #edf0f6;
    }

    .wrap1 .withdraw_wrap input {
        flex: 1;
        width: auto;
        height: 34px;
        color: #050b18;
        font-size: 14px;
        line-height: 34px;
    }

    .wrap1 .withdraw_wrap input::placeholder {
        color: #a4aab6;
    }

    .wrap1 .withdraw_wrap div span:nth-child(2) {
        width: auto;
        margin-left: 12px;
        color: #8b93a3;
        font-size: 12px;
        font-weight: 500;
    }

    .wrap1 .withdraw_wrap > p:nth-child(3),
    .wrap1 .withdraw_wrap > p:nth-child(4) {
        margin: 10px 0 0;
        color: #8b93a3;
        font-size: 12px;
        line-height: 18px;
    }

    .wrap1 .choose_bank {
        display: grid;
        grid-template-columns: 88px minmax(0, 1fr);
        column-gap: 12px;
        align-items: center;
    }

    .wrap1 .choose_bank div:nth-child(1),
    .wrap1 .choose_bank div:nth-child(2) {
        width: auto;
    }

    .wrap1 .choose_bank div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: 0;
        color: #687083;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
    }

    .wrap1 .choose_bank div:nth-child(2) > span {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .canal_tips {
        border-top: 0;
        color: #ff4551;
        font-size: 12px;
        line-height: 20px;
    }

    .basic_btn {
        width: calc(100% - 32px);
        height: 48px;
        margin: 24px 16px 0;
        border-radius: 12px;
        background: linear-gradient(135deg, #ff6764 0%, #ff3346 100%);
        box-shadow: 0 8px 20px rgba(255, 51, 70, .18);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 48px;
    }

    .real_name_mask .basic_btn {
		width: 70%;
		margin: 10px auto;
    }

    /deep/ .van-popup--bottom {
        position: fixed;
        border-radius: 16px 16px 0 0;
    }
</style>
